"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserProvider = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_router_1 = require("react-router");
var provider_api_1 = require("@framework/provider-api");
var context_1 = require("./context");
var interfaces_1 = require("./interfaces");
var utils_1 = require("./utils");
var getCurrentPath = function () { return "".concat(window.location.pathname).concat(window.location.search).concat(window.location.hash); };
var UserProvider = function (props) {
    var customLogIn = props.customLogIn, customGuestCheckPasswordPolicy = props.customGuestCheckPasswordPolicy, customSetNewPassword = props.customSetNewPassword, customLogOut = props.customLogOut, profile = props.profile, setUserProfile = props.setUserProfile, _a = props.storageName, storageName = _a === void 0 ? "user" : _a, children = props.children;
    var navigate = (0, react_router_1.useNavigate)();
    var api = (0, provider_api_1.useApi)();
    var _b = (0, react_1.useState)(true), isLoading = _b[0], setIsLoading = _b[1];
    var _c = (0, react_1.useState)(0), pendingSettingsUpdates = _c[0], setPendingSettingsUpdates = _c[1];
    var profileRef = (0, react_1.useRef)(profile);
    profileRef.current = profile;
    var runSettingsUpdate = (0, react_1.useCallback)(function (operation) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setPendingSettingsUpdates(function (count) { return count + 1; });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 3, 4]);
                    return [4 /*yield*/, operation()];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    setPendingSettingsUpdates(function (count) { return count - 1; });
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); }, []);
    var selectLatestProfile = (0, react_1.useCallback)(function (incoming) {
        if (!incoming ||
            typeof incoming.settingsResetRevision !== "number" ||
            !Number.isFinite(incoming.settingsResetRevision)) {
            return incoming;
        }
        var latest = incoming;
        var useNewerProfile = function (candidate) {
            var _a, _b;
            if ((candidate === null || candidate === void 0 ? void 0 : candidate.id) === incoming.id &&
                typeof candidate.settingsResetRevision === "number" &&
                Number.isFinite(candidate.settingsResetRevision) &&
                ((_a = candidate.settingsResetRevision) !== null && _a !== void 0 ? _a : 0) > ((_b = latest.settingsResetRevision) !== null && _b !== void 0 ? _b : 0)) {
                latest = candidate;
            }
        };
        useNewerProfile(profileRef.current);
        try {
            var cached = localStorage.getItem(storageName);
            if (cached)
                useNewerProfile(JSON.parse(cached));
        }
        catch (_a) {
            return latest;
        }
        return latest;
    }, [storageName]);
    var setProfileHandle = (0, react_1.useCallback)(function (incoming) {
        var latest = selectLatestProfile(incoming);
        profileRef.current = latest;
        setUserProfile(latest);
        (0, utils_1.saveProfileToLocalStorage)(storageName, latest);
        return latest;
    }, [setUserProfile, storageName, selectLatestProfile]);
    var setInterfaceSettings = (0, react_1.useCallback)(function (data) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, api.fetchJson({
                        url: "/users/interface-settings",
                        method: "PUT",
                        data: __assign(__assign({}, data), { settingsResetRevision: profile === null || profile === void 0 ? void 0 : profile.settingsResetRevision }),
                    })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [api, profile === null || profile === void 0 ? void 0 : profile.settingsResetRevision]);
    var setSelfRecorderSettings = (0, react_1.useCallback)(function (data) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, api.fetchJson({
                        url: "/users/self-recorder-settings",
                        method: "PUT",
                        data: __assign(__assign({}, data), { settingsResetRevision: profile === null || profile === void 0 ? void 0 : profile.settingsResetRevision }),
                    })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [api, profile === null || profile === void 0 ? void 0 : profile.settingsResetRevision]);
    var setSchemePageOrder = (0, react_1.useCallback)(function (data) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, api.fetchJson({
                        url: "/users/scheme-page-order",
                        method: "PUT",
                        data: __assign(__assign({}, data), { settingsResetRevision: profile === null || profile === void 0 ? void 0 : profile.settingsResetRevision }),
                    })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [api, profile === null || profile === void 0 ? void 0 : profile.settingsResetRevision]);
    var getRawProfile = (0, react_1.useCallback)(function () { return __awaiter(void 0, void 0, void 0, function () {
        var e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, api.fetchJson({
                            url: "/auth/me",
                        })];
                case 1: return [2 /*return*/, (_a.sent())];
                case 2:
                    e_1 = _a.sent();
                    if (e_1 instanceof provider_api_1.ApiError && e_1.status === 401 && window.location.pathname !== "/login") {
                        navigate("/login", {
                            state: {
                                from: getCurrentPath(),
                            },
                        });
                    }
                    throw e_1;
                case 3: return [2 /*return*/];
            }
        });
    }); }, [api, navigate]);
    var getProfile = (0, react_1.useCallback)(function (url) { return __awaiter(void 0, void 0, void 0, function () {
        var json, transformedProfile, e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, api.fetchJson({
                            url: "/auth/me",
                        })];
                case 1:
                    json = (_a.sent());
                    if (!json) {
                        setProfileHandle(null);
                        if (window.location.pathname !== "/login") {
                            navigate("/login", {
                                state: {
                                    from: getCurrentPath(),
                                },
                            });
                        }
                        return [2 /*return*/, null];
                    }
                    transformedProfile = setProfileHandle(json);
                    if (url) {
                        navigate(url, { replace: true });
                    }
                    return [2 /*return*/, transformedProfile];
                case 2:
                    e_2 = _a.sent();
                    if (e_2 instanceof provider_api_1.ApiError && e_2.status === 401) {
                        setProfileHandle(null);
                        if (window.location.pathname !== "/login") {
                            navigate("/login", {
                                state: {
                                    from: getCurrentPath(),
                                },
                            });
                        }
                    }
                    throw e_2;
                case 3: return [2 /*return*/];
            }
        });
    }); }, [api, navigate, setProfileHandle]);
    var logIn = (0, react_1.useCallback)(function (data, url) { return __awaiter(void 0, void 0, void 0, function () {
        var key, encryptedPassword, jwt, profile_1, e_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!data) {
                        return [2 /*return*/, null];
                    }
                    return [4 /*yield*/, api.fetchJson({
                            url: "/auth/genpk",
                            method: "POST",
                            data: { usr_key: data.login },
                        })];
                case 1:
                    key = (_a.sent());
                    return [4 /*yield*/, (0, provider_api_1.encryptLoginPasswordRsaOaep)(key.pk, data.password)];
                case 2:
                    encryptedPassword = _a.sent();
                    _a.label = 3;
                case 3:
                    _a.trys.push([3, 6, , 7]);
                    return [4 /*yield*/, api.fetchJson({
                            url: "/auth/login",
                            method: "POST",
                            data: {
                                login: data.login,
                                password: encryptedPassword,
                            },
                        })];
                case 4:
                    jwt = (_a.sent());
                    api.setToken(jwt);
                    return [4 /*yield*/, getProfile(url)];
                case 5:
                    profile_1 = _a.sent();
                    if (profile_1 === null || profile_1 === void 0 ? void 0 : profile_1.id) {
                        window.dispatchEvent(new CustomEvent("user_logged_in", { detail: { userId: profile_1.id } }));
                    }
                    return [2 /*return*/, profile_1];
                case 6:
                    e_3 = _a.sent();
                    api.setToken(null);
                    throw e_3;
                case 7: return [2 /*return*/];
            }
        });
    }); }, [api, getProfile]);
    var logOut = (0, react_1.useCallback)(function (url) { return __awaiter(void 0, void 0, void 0, function () {
        var e_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, api.fetchJson({
                            url: "/auth/logout",
                            method: "DELETE",
                        })];
                case 1:
                    _a.sent();
                    setProfileHandle(null);
                    api.setToken(null);
                    if (url) {
                        navigate(url);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_4 = _a.sent();
                    api.setToken(null);
                    throw e_4;
                case 3: return [2 /*return*/];
            }
        });
    }); }, [api, navigate, setProfileHandle]);
    var guestCheckPasswordPolicy = (0, react_1.useCallback)(function (login, password) { return __awaiter(void 0, void 0, void 0, function () {
        var usrKey, key, encryptedPassword, query, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    usrKey = login.trim().toLowerCase();
                    return [4 /*yield*/, api.fetchJson({
                            url: "/auth/genpk",
                            method: "POST",
                            data: { usr_key: usrKey },
                        })];
                case 1:
                    key = (_a.sent());
                    return [4 /*yield*/, (0, provider_api_1.encryptLoginPasswordRsaOaep)(key.pk, password)];
                case 2:
                    encryptedPassword = _a.sent();
                    query = "login=".concat(encodeURIComponent(usrKey), "&password=").concat(encodeURIComponent(encryptedPassword));
                    _a.label = 3;
                case 3:
                    _a.trys.push([3, 5, , 6]);
                    return [4 /*yield*/, api.fetchJson({
                            url: "/auth/check-password-policy?".concat(query),
                            headers: {
                                accept: "application/json",
                            },
                        })];
                case 4:
                    _a.sent();
                    return [3 /*break*/, 6];
                case 5:
                    error_1 = _a.sent();
                    if (error_1 instanceof provider_api_1.ApiError) {
                        throw error_1;
                    }
                    else {
                        throw new Error("Unexpected error: ".concat(error_1));
                    }
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/];
            }
        });
    }); }, [api]);
    var setNewPassword = (0, react_1.useCallback)(function (data, url) { return __awaiter(void 0, void 0, void 0, function () {
        var usrKey, key, encryptedCurrent, encryptedNew;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!data) {
                        return [2 /*return*/];
                    }
                    usrKey = data.login.trim().toLowerCase();
                    return [4 /*yield*/, api.fetchJson({
                            url: "/auth/genpk",
                            method: "POST",
                            data: { usr_key: usrKey },
                        })];
                case 1:
                    key = (_a.sent());
                    return [4 /*yield*/, (0, provider_api_1.encryptLoginPasswordRsaOaep)(key.pk, data.currentPassword)];
                case 2:
                    encryptedCurrent = _a.sent();
                    return [4 /*yield*/, (0, provider_api_1.encryptLoginPasswordRsaOaep)(key.pk, data.newPassword)];
                case 3:
                    encryptedNew = _a.sent();
                    return [4 /*yield*/, api.fetchJson({
                            url: "/auth/set-new-password",
                            method: "POST",
                            data: __assign(__assign({}, data), { currentPassword: encryptedCurrent, newPassword: encryptedNew }),
                        })];
                case 4:
                    _a.sent();
                    if (url) {
                        navigate(url);
                    }
                    return [2 /*return*/];
            }
        });
    }); }, [api, navigate]);
    var isAuthenticated = (0, react_1.useCallback)(function () {
        return profile !== null;
    }, [profile]);
    var isAdmin = (0, react_1.useCallback)(function () {
        return (profile === null || profile === void 0 ? void 0 : profile.userGroup) === interfaces_1.UserGroup.ADMINISTRATOR;
    }, [profile]);
    var handleSessionExpired = (0, react_1.useCallback)(function () {
        setProfileHandle(null);
        api.setToken(null);
        if (window.location.pathname !== "/login") {
            navigate("/login", {
                replace: true,
                state: {
                    from: getCurrentPath(),
                    reason: "session_expired",
                },
            });
        }
    }, [navigate, setProfileHandle, api]);
    (0, react_1.useEffect)(function () {
        window.addEventListener("session_expired", handleSessionExpired);
        return function () {
            window.removeEventListener("session_expired", handleSessionExpired);
        };
    }, [handleSessionExpired]);
    (0, react_1.useEffect)(function () {
        var handleProfileStorage = function (event) {
            var _a;
            if (event.key !== storageName || event.storageArea !== localStorage || !event.newValue)
                return;
            var incoming;
            try {
                incoming = JSON.parse(event.newValue);
            }
            catch (_b) {
                return;
            }
            var current = profileRef.current;
            if (current &&
                (incoming === null || incoming === void 0 ? void 0 : incoming.id) === current.id &&
                typeof incoming.settingsResetRevision === "number" &&
                Number.isFinite(incoming.settingsResetRevision) &&
                incoming.settingsResetRevision > ((_a = current.settingsResetRevision) !== null && _a !== void 0 ? _a : 0)) {
                var latest = selectLatestProfile(incoming);
                profileRef.current = latest;
                setUserProfile(latest);
            }
        };
        window.addEventListener("storage", handleProfileStorage);
        return function () { return window.removeEventListener("storage", handleProfileStorage); };
    }, [setUserProfile, storageName, selectLatestProfile]);
    (0, react_1.useEffect)(function () {
        var fetchUserProfile = function () { return __awaiter(void 0, void 0, void 0, function () {
            var auth, parsedAuth, initialProfile, rawUserProfile, updatedProfile, error_2, profileWithBaseVersion, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        auth = localStorage.getItem(storageName);
                        parsedAuth = auth ? JSON.parse(auth) : null;
                        initialProfile = selectLatestProfile(parsedAuth);
                        profileRef.current = initialProfile;
                        setUserProfile(initialProfile);
                        if (!(parsedAuth && parsedAuth.id)) return [3 /*break*/, 5];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, getRawProfile()];
                    case 2:
                        rawUserProfile = _a.sent();
                        updatedProfile = __assign(__assign({}, rawUserProfile), { version: rawUserProfile.version });
                        setProfileHandle(updatedProfile);
                        return [3 /*break*/, 4];
                    case 3:
                        error_2 = _a.sent();
                        if (error_2 instanceof provider_api_1.ApiError && error_2.status === 401) {
                            if (window.location.pathname !== "/login") {
                                navigate("/login", {
                                    state: {
                                        from: getCurrentPath(),
                                    },
                                });
                            }
                            setProfileHandle(null);
                        }
                        else {
                            profileWithBaseVersion = __assign(__assign({}, parsedAuth), { version: interfaces_1.UserVersion.BASE });
                            setProfileHandle(profileWithBaseVersion);
                        }
                        return [3 /*break*/, 4];
                    case 4: return [3 /*break*/, 8];
                    case 5:
                        _a.trys.push([5, 7, , 8]);
                        return [4 /*yield*/, getProfile()];
                    case 6:
                        _a.sent();
                        return [3 /*break*/, 8];
                    case 7:
                        error_3 = _a.sent();
                        if (!(error_3 instanceof provider_api_1.ApiError && error_3.status === 401)) {
                            console.error("Failed to fetch profile from server", error_3);
                        }
                        if (error_3 instanceof provider_api_1.ApiError && error_3.status === 401) {
                            if (window.location.pathname !== "/login") {
                                navigate("/login", {
                                    state: {
                                        from: getCurrentPath(),
                                    },
                                });
                            }
                        }
                        return [3 /*break*/, 8];
                    case 8:
                        setIsLoading(false);
                        return [2 /*return*/];
                }
            });
        }); };
        void fetchUserProfile();
    }, []);
    var contextValue = (0, react_1.useMemo)(function () { return ({
        profile: profile,
        getProfile: getProfile,
        getRawProfile: getRawProfile,
        logIn: customLogIn || logIn,
        logOut: customLogOut || logOut,
        guestCheckPasswordPolicy: customGuestCheckPasswordPolicy || guestCheckPasswordPolicy,
        setNewPassword: customSetNewPassword || setNewPassword,
        setInterfaceSettings: setInterfaceSettings,
        setSelfRecorderSettings: setSelfRecorderSettings,
        setSchemePageOrder: setSchemePageOrder,
        runSettingsUpdate: runSettingsUpdate,
        isSavingSettings: pendingSettingsUpdates > 0,
        isAuthenticated: isAuthenticated,
        isAdmin: isAdmin,
        isLoading: isLoading,
    }); }, [
        profile,
        getProfile,
        getRawProfile,
        customLogIn,
        logIn,
        customLogOut,
        logOut,
        customGuestCheckPasswordPolicy,
        guestCheckPasswordPolicy,
        customSetNewPassword,
        setNewPassword,
        setInterfaceSettings,
        setSelfRecorderSettings,
        setSchemePageOrder,
        runSettingsUpdate,
        pendingSettingsUpdates,
        isAuthenticated,
        isAdmin,
        isLoading,
    ]);
    return (0, jsx_runtime_1.jsx)(context_1.UserContext.Provider, { value: contextValue, children: children });
};
exports.UserProvider = UserProvider;
//# sourceMappingURL=provider.js.map